import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon, CheckCircleIcon } from 'lucide-react';
const NAMES = ['Martín', 'Lucía', 'Valentina', 'Santiago', 'Camila', 'Mateo', 'Sofía', 'Tomás', 'Florencia', 'Joaquín', 'Milagros', 'Agustín', 'Julieta', 'Nicolás', 'Catalina', 'Facundo', 'Rocío', 'Lautaro', 'Micaela', 'Gonzalo', 'Aldana', 'Ignacio', 'Brenda', 'Federico', 'Candela', 'Ezequiel', 'Pilar', 'Thiago', 'Abril', 'Ramiro', 'Delfina', 'Leandro', 'Mora', 'Emiliano', 'Bianca'];
const LOCATIONS = ['La Plata', 'Quilmes', 'Lomas de Zamora', 'San Isidro', 'Morón', 'Avellaneda', 'Lanús', 'Tigre', 'Vicente López', 'Florencio Varela', 'Berazategui', 'San Martín', 'Tres de Febrero', 'Merlo', 'Moreno', 'José C. Paz', 'San Miguel', 'Ituzaingó', 'Hurlingham', 'Esteban Echeverría', 'Almirante Brown', 'Ezeiza', 'Pilar', 'Escobar', 'Zárate', 'Campana', 'San Fernando', 'San Nicolás', 'Bahía Blanca', 'Mar del Plata', 'Tandil', 'Olavarría', 'Junín', 'Pergamino', 'Luján', 'CABA', 'Palermo', 'Belgrano', 'Caballito', 'Flores', 'Villa Urquiza', 'Almagro', 'Recoleta', 'Núñez', 'Barracas'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getTimeAgo(): string {
  const mins = Math.floor(Math.random() * 12) + 1;
  return `hace ${mins} min`;
}
interface Notification {
  id: number;
  name: string;
  location: string;
  timeAgo: string;
}
export function PurchaseNotifications() {
  const [notification, setNotification] = useState<Notification | null>(null);
  const [counter, setCounter] = useState(0);
  const createNotification = useCallback(() => {
    setCounter(prev => prev + 1);
    setNotification({
      id: Date.now(),
      name: getRandomItem(NAMES),
      location: getRandomItem(LOCATIONS),
      timeAgo: getTimeAgo()
    });
    // Auto-dismiss after 3.5 seconds
    setTimeout(() => {
      setNotification(null);
    }, 3500);
  }, []);
  useEffect(() => {
    // Show first notification after 3 seconds
    const initialTimeout = setTimeout(() => {
      createNotification();
    }, 3000);
    // Then every 5 seconds
    const interval = setInterval(() => {
      createNotification();
    }, 5000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [createNotification]);
  return <div className="fixed bottom-4 left-4 z-[9999] pointer-events-none" data-id="element-256">
      <AnimatePresence mode="wait" data-id="element-257">
        {notification && <motion.div key={notification.id} initial={{
        opacity: 0,
        y: 60,
        x: -20,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        x: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        x: -40,
        scale: 0.95
      }} transition={{
        type: 'spring',
        stiffness: 350,
        damping: 25,
        mass: 0.8
      }} className="pointer-events-auto max-w-[340px] w-max" data-id="element-258">
            <div className="bg-[#1a1625]/95 backdrop-blur-xl border border-white/10 rounded-2xl p-4 shadow-[0_8px_32px_rgba(0,0,0,0.5),0_0_20px_rgba(138,43,226,0.15)] flex items-start gap-3" data-id="element-259">
              {/* Icon */}
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gradient-to-br from-[#10B981] to-[#047857] flex items-center justify-center shadow-[0_0_12px_rgba(16,185,129,0.4)]" data-id="element-260">
                <ShoppingBagIcon className="w-5 h-5 text-white" data-id="element-261" />
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0" data-id="element-262">
                <div className="flex items-center gap-1.5 mb-0.5" data-id="element-263">
                  <CheckCircleIcon className="w-3.5 h-3.5 text-[#10B981] flex-shrink-0" data-id="element-264" />
                  <span className="text-[#10B981] text-xs font-bold tracking-wide uppercase" data-id="element-265">
                    Compra verificada
                  </span>
                </div>
                <p className="text-white text-sm font-semibold leading-snug" data-id="element-266">
                  {notification.name}{' '}
                  <span className="text-white/60 font-normal" data-id="element-267">de</span>{' '}
                  <span className="text-white/90" data-id="element-268">{notification.location}</span>
                </p>
                <p className="text-white/50 text-xs mt-0.5" data-id="element-269">
                  compró el{' '}
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-gradOrange to-gradPink font-bold" data-id="element-270">
                    MegaPack
                  </span>{' '}
                  · {notification.timeAgo}
                </p>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}